<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "JBProposalBurglarAlarms",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					label: "13. (a) Is there a Burglar Alarm?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0AlarmInstalledId",
					props: {
						suggest: {
							typeIncludes: "alarmInstalled"
						},
						createOptions: {
							type: "alarmInstalled",
							dataType: "string"
						}
					}
				},
				{
					label:
						"13. (b) If so, state name and forward copy of maker's specification to Underwriters (or if not available give full details).",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0AlarmDetailsId",
					props: {
						suggest: {
							typeIncludes: "alarmDetails"
						},
						createOptions: {
							type: "alarmDetails",
							dataType: "string"
						}
					}
				},
				{
					label: "13. (c) Are holdup/panic buttons incorporated in the system?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0HoldupButtonIncorporatedId",
					props: {
						suggest: {
							typeIncludes: "holdupButtonIncorporated"
						},
						createOptions: {
							type: "holdupButtonIncorporated",
							dataType: "string"
						}
					}
				},
				{
					label: "13. (d) Is the system maintained under contract?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0SystemMaintainedId",
					props: {
						suggest: {
							typeIncludes: "systemMaintainedUnderContract"
						},
						createOptions: {
							type: "systemMaintainedUnderContract",
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
